// extracted by mini-css-extract-plugin
export default {"sectionWrapper":"dq-z","outfitFeedbackSection":"eq-z"};